"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withApollo = withApollo;
exports.wrapServerSideProps = wrapServerSideProps;
exports.WITH_APOLLO_COMPONENT_NAME = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _apolloUtils = require("@chegg-web-tools/apollo-utils");

var _client = require("@apollo/client");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var WITH_APOLLO_COMPONENT_NAME = 'WithApolloPageHelper';
exports.WITH_APOLLO_COMPONENT_NAME = WITH_APOLLO_COMPONENT_NAME;

function withApollo(Page) {
  var withSsr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (Page.displayName == WITH_APOLLO_COMPONENT_NAME) {
    return Page;
  }

  var WithApollo = function WithApollo(props) {
    return /*#__PURE__*/_react["default"].createElement(_client.ApolloProvider, {
      client: (0, _apolloUtils.getClient)()
    }, /*#__PURE__*/_react["default"].createElement(Page, props));
  };

  WithApollo.displayName = WITH_APOLLO_COMPONENT_NAME;

  if (withSsr) {
    WithApollo.getInitialProps = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx) {
        var getInitialProps, pageProps;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getInitialProps = Page.getInitialProps || emptyGetInitialProps;

                if (ctx.req) {
                  (0, _apolloUtils._getClientWithCookies)(ctx.req.headers['cookie']);
                } else {
                  (0, _apolloUtils.getClient)();
                }

                _context.next = 4;
                return getInitialProps(ctx);

              case 4:
                pageProps = _context.sent;
                return _context.abrupt("return", _objectSpread({}, pageProps));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  }

  return WithApollo;
}

function wrapServerSideProps(wrapped) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0, _apolloUtils._getClientWithCookies)(ctx.req.headers['cookie']);
              return _context2.abrupt("return", wrapped(ctx));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function emptyGetInitialProps() {
  return Promise.resolve({});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/with-chegg/dist/withApollo.js
// module id = 1649
// module chunks = 11